export default __webpack_public_path__ + "static/media/logo.3c6fcc40.svg";